module.exports = __webpack_public_path__ + "img/箭头@2x.d1d6d567.png";